import { ApiResponse, axiosInstance } from '@/lib/axios';
import { queryOptions, useQuery } from '@tanstack/react-query';
import { QueryConfig } from '@/lib/react-query';
import { TFetchParams } from '@/types/fetch.type';
import { TSpaceMember } from '@/features/ticketings/ticketing-user/types/ticketing-user.type';
import { IPagination } from '@/types/general.type';

export type TGetListSpaceMemberResponse = ApiResponse<IPagination<TSpaceMember>>;
export type TGetListSpaceMemberParams = TFetchParams & {
  spaceId: string;
};

export const getListSpaceMember = async (params: TGetListSpaceMemberParams): Promise<TGetListSpaceMemberResponse> => {
  const url = '/space-member';

  return axiosInstance.get(url, { params });
};

export const GET_LIST_SPACE_MEMBER_QUERY_KEY = 'get-list-space-member';

export const getListSpaceMemberQueryOptions = (params: TGetListSpaceMemberParams) => {
  return queryOptions({
    queryKey: [
      GET_LIST_SPACE_MEMBER_QUERY_KEY,
      {
        spaceId: params?.spaceId,
        search: params?.search,
        page: params?.page,
        limit: params?.limit,
        sortDir: params?.sortDir,
        sortBy: params?.sortBy,
      },
    ],
    queryFn: () => getListSpaceMember(params),
  });
};

type UseListSpaceMemberQueryQueryOptions = {
  params: TGetListSpaceMemberParams;
  queryConfig?: QueryConfig<typeof getListSpaceMemberQueryOptions>;
};

export const useListSpaceMemberQuery = ({ queryConfig, params }: UseListSpaceMemberQueryQueryOptions) => {
  return useQuery({ ...getListSpaceMemberQueryOptions(params), ...queryConfig });
};
